import { render, staticRenderFns } from "./MarketplaceDiscountTemplate.vue?vue&type=template&id=5df5e3c3&scoped=true&"
import script from "./MarketplaceDiscountTemplate.vue?vue&type=script&lang=js&"
export * from "./MarketplaceDiscountTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5e3c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df5e3c3')) {
      api.createRecord('5df5e3c3', component.options)
    } else {
      api.reload('5df5e3c3', component.options)
    }
    module.hot.accept("./MarketplaceDiscountTemplate.vue?vue&type=template&id=5df5e3c3&scoped=true&", function () {
      api.rerender('5df5e3c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/MarketplaceDiscountTemplate.vue"
export default component.exports